(function () {
  // ---------- Toast ----------
  function showToast(msg) {
    var toast = document.querySelector('.scoop-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'scoop-toast';
      document.body.appendChild(toast);
    }
    toast.textContent = msg;
    toast.classList.add('is-visible');
    clearTimeout(toast._timer);
    toast._timer = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 2200);
  }
 
  // ---------- Cart count badge ----------
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }
 
  function refreshCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); })
      .catch(function () {});
  }
 
  // ---------- Quick add to cart (Ajax, no page reload) ----------
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.scoop-quick-add');
    if (!btn) return;
    e.preventDefault();
    if (btn.classList.contains('is-loading')) return;
 
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) {
      showToast('This product is unavailable');
      return;
    }
 
    var originalHTML = btn.innerHTML;
    btn.classList.add('is-loading');
    btn.innerHTML = '···';
 
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        btn.innerHTML = '✓';
        showToast('Added to cart!');
        refreshCartCount();
        setTimeout(function () {
          btn.classList.remove('is-added');
          btn.innerHTML = originalHTML;
        }, 1400);
      })
      .catch(function (err) {
        btn.classList.remove('is-loading');
        btn.innerHTML = originalHTML;
        showToast((err && err.description) || 'Could not add to cart');
      });
  });
 
  // ---------- Wishlist (localStorage) ----------
  var WISHLIST_KEY = 'scoop_wishlist';
 
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; }
    catch (e) { return []; }
  }
 
  function saveWishlist(list) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
    updateWishlistCount();
  }
 
  function updateWishlistCount() {
    var count = getWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }
 
  function isFavorited(handle) {
    return getWishlist().some(function (item) { return item.handle === handle; });
  }
 
  function paintFavoriteButtons() {
    document.querySelectorAll('.product-favorite').forEach(function (btn) {
      var handle = btn.getAttribute('data-handle');
      if (!handle) return;
      if (isFavorited(handle)) {
        btn.classList.add('is-active');
        btn.textContent = '♥';
      } else {
        btn.classList.remove('is-active');
        btn.textContent = '♡';
      }
    });
  }
 
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.product-favorite');
    if (!btn) return;
    e.preventDefault();
 
    var handle = btn.getAttribute('data-handle');
    if (!handle) return;
 
    var list = getWishlist();
    var idx = list.findIndex(function (item) { return item.handle === handle; });
 
    if (idx > -1) {
      list.splice(idx, 1);
      showToast('Removed from favorites');
    } else {
      list.push({
        handle: handle,
        title: btn.getAttribute('data-title') || '',
        price: btn.getAttribute('data-price') || '',
        image: btn.getAttribute('data-image') || '',
        url: btn.getAttribute('data-url') || ('/products/' + handle),
        variantId: btn.getAttribute('data-variant-id') || '',
        isNew: btn.getAttribute('data-is-new') === 'true'
      });
      showToast('Added to favorites ♥');
    }
 
    saveWishlist(list);
    paintFavoriteButtons();
  });
 
  // ---------- Render the Favorites page (if present) ----------
  function renderFavoritesPage() {
    var grid = document.querySelector('[data-favorites-grid]');
    if (!grid) return;
    var list = getWishlist();
 
    if (list.length === 0) {
      grid.innerHTML = '<p class="favorites-empty">No favorites yet — tap the heart on any slime to save it here!</p>';
      return;
    }
 
    grid.innerHTML = list.map(function (item) {
      return '' +
        '<article class="product-card">' +
          '<a href="' + item.url + '">' +
            '<div class="product-image">' +
              '<img src="' + item.image + '" alt="' + item.title + '" loading="lazy">' +
              (item.isNew ? '<span class="product-badge">New</span>' : '') +
              '<button type="button" class="product-favorite is-active" data-handle="' + item.handle + '" data-title="' + item.title + '" data-price="' + item.price + '" data-image="' + item.image + '" data-url="' + item.url + '">♥</button>' +
            '</div>' +
          '</a>' +
          '<div class="product-info">' +
            '<h3><a href="' + item.url + '">' + item.title + '</a></h3>' +
            '<div class="product-bottom">' +
              '<span class="product-price">' + item.price + '</span>' +
              '<button type="button" class="scoop-quick-add" data-variant-id="' + item.variantId + '">+</button>' +
            '</div>' +
          '</div>' +
        '</article>';
    }).join('');
  }
 
  document.addEventListener('DOMContentLoaded', function () {
    paintFavoriteButtons();
    updateWishlistCount();
    refreshCartCount();
    renderFavoritesPage();
  });
})();
 